let baseURL = "https://app.nmp.com.pk/api/";

export default baseURL;
